export default {
  'Screenshot': '截圖',
}